import { useState } from "react";
import { ApiService } from "~/utils/service";
import useLocale from "./useLocale";

export interface AudioBookPath {
  fullPath: string;
  urlSlugs: string[];
}
const useNavigateAudioBook = (lang: "en" | "gu") => {
  const apiService = new ApiService(lang);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { navigate } = useLocale();

  const handleNavigateAudioBook = async (bookId: number) => {
    setIsLoading(true);
    const response: AudioBookPath = await apiService.getAudioUrlToNavigate(bookId);
    if (response) {
      navigate(response.fullPath);
    }
    setIsLoading(false);
  };
  return { isLoading, handleNavigateAudioBook };
};

export default useNavigateAudioBook;
